import React from "react";
import DashboardAdmin from "./dashboard-admin";
import { useLocation, useParams } from "react-router-dom";

interface MspDashboardProps {
  role?: "superadmin" | "msp";
  mspId?: number;
}

const MSP_ID_IN_CUSTOMERS_PATH_REGEX = /\/msps\/(\d+)\/customers/;
const MSP_ID_AT_END_OF_PATH_REGEX = /\/msps\/(\d+)$/;

export default function MspDashboard({
  role,
  mspId: propMspId,
}: Readonly<MspDashboardProps>) {
  const { mspId: urlMspId } = useParams();
  const location = useLocation();

  const extractMspIdFromPath = (pathname: string): number | undefined => {
    const mspIdFromCustomersPath =
      MSP_ID_IN_CUSTOMERS_PATH_REGEX.exec(pathname)?.[1];
    if (mspIdFromCustomersPath)
      return Number.parseInt(mspIdFromCustomersPath, 10);

    const mspIdFromEndOfPath = MSP_ID_AT_END_OF_PATH_REGEX.exec(pathname)?.[1];
    if (mspIdFromEndOfPath) return Number.parseInt(mspIdFromEndOfPath, 10);

    return undefined;
  };

  const mspIdFromPath = extractMspIdFromPath(location.pathname);
  const mspIdFromUrlParam = urlMspId
    ? Number.parseInt(urlMspId, 10)
    : undefined;

  const effectiveMspId = mspIdFromPath ?? mspIdFromUrlParam ?? propMspId;

  return <DashboardAdmin role={role ?? "superadmin"} mspId={effectiveMspId} />;
}
